import Ten99s from 'Agent/1099s/components/1099';
import {changeTen99Filters, EmptyTen99Filter} from 'Agent/1099s/ducks/1099';
import Ten99RouteConstants from 'Agent/1099s/Ten99RouteConstants';
import React from 'react';
import {Route, RouteComponentProps} from 'react-router-dom';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import useOnNavigateAway from 'Shared/utilities/useOnNavigateAway';

type Ten99RouteProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

export default ({match, selectedAgency}: Ten99RouteProps) => {
  useOnNavigateAway(Ten99RouteConstants.TEN99s, () => changeTen99Filters(EmptyTen99Filter));

  return (
    <Route
      exact
      path={`${match.url}/taxStatements`}
      render={routeProps => <Ten99s {...routeProps} selectedAgency={selectedAgency} />}
    />
  );
};
